import React from "react";
import ProgressBar from "../ProgressBar/ProgressBar";
import CandidateSignupButton from "../../pages/PostAJob/EmployerProfile/components/CandidateBackNext/CandidateSignupButton";

const FormWrapper = ({
  pageTitle,
  percent,
  nextFunction,
  backFunction,
  skipFunction,
  isOptional=false,
  children,
  loading,
  nextBtnText='Next'
}) => {
  return (
    <div className="profilecompleteion">
      <div>
        <ProgressBar heading={pageTitle} percent={percent} />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            nextFunction();
          }}
        >
          {children}
          <div style={{ paddingTop: "25%" }}>
            <CandidateSignupButton
              nextFunction={nextFunction}
              backFunction={backFunction}
              skipFunction={skipFunction}
              isOptional={isOptional}
              nextBtnLoading={loading}
              text={nextBtnText}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormWrapper;
